import React from 'react'
import LeanToImg from '../../../assets/images/information/lean-to.png'
import WraparoundsImg from '../../../assets/images/information/wraparound.png'

const InfoLeanTo = () => {
  return (
    <div>
        <div className='content-text'>
            <span>Add lean-to</span> units on sides/ends of the structure from here. Any lean-to can be customized to fit your application.
        </div>
        <div className='mt-3 pb-2'>
            <img src={process.env.REACT_APP_BASE_URL+LeanToImg} className='general-img' alt='lean-to'></img>
        </div>
        <div className='content-text mt-4'>
            Wrap Arounds are available if your provider offers them in your area. While <span>wraparounds can cover all the corners</span> of the building, the connecting lean-tos are required to be of same height and width.
        </div>
        <div className='mt-3'>
            <img src={process.env.REACT_APP_BASE_URL+WraparoundsImg} className='general-img' alt='wraparound'></img>
        </div>
    </div>
  )
}

export default InfoLeanTo